import React, { useState, useEffect } from 'react';
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc, updateDoc, arrayUnion, deleteField } from "firebase/firestore";
import { logEvent } from "firebase/analytics";
import PropertiesList from './propertiesList';
import './Modals.css'; 
import './Properties.css'; // New CSS file for styling
import Footer from './components/Footer';
import { loadStripe } from '@stripe/stripe-js';
import { useSearchParams } from 'react-router-dom';
import Confetti from 'react-confetti'; // Install with: npm install react-confetti
import { useWindowSize } from 'react-use';



function Properties({ analytics }) {
  const auth = getAuth();
  const user = auth.currentUser;
  const [searchParams] = useSearchParams();
  const { width, height } = useWindowSize();
  const [showCelebrationModal, setShowCelebrationModal] = useState(false);
  const [characteristics, setCharacteristics] = useState([]);
  const [selectedCharacteristics, setSelectedCharacteristics] = useState({});
  const [hasSelectedCharacteristics, setHasSelectedCharacteristics] = useState(false);
  const [properties, setProperties] = useState([]);
  const [propertyUrl, setPropertyUrl] = useState("");
  const [showAddPropertyModal, setShowAddPropertyModal] = useState(false);
  const [showCharacteristicsModal, setShowCharacteristicsModal] = useState(false);
  const [userTier, setUserTier] = useState("basic"); // Default to "basic"
  const [urlError, setUrlError] = useState("");
  const [isCharacteristicsInitialized, setIsCharacteristicsInitialized] = useState(false);
  const [isAdding, setIsAdding] = useState(false); // New state for button loading
  const [addError, setAddError] = useState(""); // New state for error message
  const [showUpgradeModal, setShowUpgradeModal] = useState(false); // New state for modal visibility
  const [currentStep, setCurrentStep] = useState(1); // Track the current step


  const stripe_product_key = process.env.NODE_ENV === 'production'
  ? `pk_live_51QdqEtBbIoG4k6cETRgLRYPAuY0DWyzPg7S7bwSn2i4VyJewVcQvThB9JCKvufFz7fJUwxOYw7kDChooxwpi7Lam00kRQyFv5t`
  : `pk_test_51QdqEtBbIoG4k6cEDl2rypEk7zMThQL4f2EmTSkMn3SGKBjsOoUzyQ29Fx27Mo3CTXyQUxECsVS73Seq54onGfZJ006rgcqXY7`;


  const serverUrl = process.env.REACT_APP_NODE_ENV === 'production'
  ? process.env.REACT_APP_PRODUCTION_SERVER_URL
  : process.env.REACT_APP_LOCAL_SERVER_URL;


  const stripePromise = loadStripe(stripe_product_key);

useEffect(() => {

  const fetchData = async () => {
    const db = getFirestore();
    if (user) {
      const userDocRef = doc(db, "userPreferences", user.uid);
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists()) {
        const data = userDocSnap.data();
        const characteristics = data.selectedCharacteristics || {};
        setUserTier(data.tier || "basic"); // Fetch tier from Firestore
        setSelectedCharacteristics(characteristics);
        const isSelected = Object.keys(characteristics).length > 0;
        setHasSelectedCharacteristics(isSelected); // Update the state here
        setProperties(data.properties || []);
        setIsCharacteristicsInitialized(true); // Explicitly mark initialization complete
      }
    }
    const docRef = doc(db, "property-characteristics", "global");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setCharacteristics(docSnap.data().global);
    } else {
      console.error("No property characteristics found!");
    }
    
  };

  fetchData();
}, [user]);

useEffect(() => {
  if (searchParams.get("tier") === "premium") {
    setShowCelebrationModal(true);
  }
}, [searchParams]);


useEffect(() => {
  if (showCharacteristicsModal || showAddPropertyModal) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }

  // Cleanup on unmount
  return () => {
    document.body.classList.remove('modal-open');
  };
}, [showCharacteristicsModal, showAddPropertyModal]);

  const handleSaveStep1 = () => {
    if (Object.keys(selectedCharacteristics).length === 0) {
      alert("Please select at least one characteristic.");
      return;
    }
    setCurrentStep(2); // Move to the slider step
  };

  const handleSaveStep2 = async () => {
    await saveCharacteristics(); // Ensure characteristics are saved to Firestore
    setCurrentStep(1); // Move to the properties display step
  };

  const handleBackStep2 = () => {
    setCurrentStep(1); // Go back to selecting characteristics
  };

  const handleBackStep3 = () => {
    setCurrentStep(2); // Go back to adjusting slider values
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <>
          <div style={{marginTop:"16px"}}><p>Welcome to Domogogo, we're happy to have you! Start by selecting some of the <i>characteristics</i> that are important to you in your property search. Don't worry, you can always add more later.</p><br/></div>
            <div className="modal-panels" style={{ display: "flex", gap: "20px" }}>
              <div className="left-panel" style={{ flex: "1", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                <h3 style={{ marginBottom: "8px" }}>Step 1: Select characteristics that are important to your property search</h3>
                <div style={{display: "flex", flexWrap: "wrap", gap: "0px"}}>
                  {characteristics.map((char, index) => (
                    <button
                      key={index}
                      className={`toggle-button ${
                        selectedCharacteristics[char.id] ? "on" : "off"
                      }`}
                      style={{
                      whiteSpace: "nowrap",
                      padding: "8px 12px", // Increase padding for better clickability
                      borderRadius: "16px",
                      marginRight: "8px",
                      marginBottom: "8px",
                      color: "#333",
                      backgroundColor: "white",
                      cursor: "pointer",
                      display: "flex", // Make the button a flex container
                      alignItems: "center", // Vertically align contents
                      }}
                      onClick={() => {
                        setSelectedCharacteristics((prev) => {
                          const updated = { ...prev };
                          if (updated[char.id]) {
                            delete updated[char.id];
                          } else {
                            updated[char.id] = 1; // Default score
                          }
                          return updated;
                        });
                      }}
                    >
                      {char.url && (
                        <img
                          src={char.url}
                          alt={`${char.name} icon`}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                          }}
                        />
                      )}
                      {char.name}
                    </button>
                  ))}
                </div>
              </div>
              
          </div>
          <button className='save-button' onClick={handleSaveStep1} style={{ marginTop: "20px" }}>
            LET'S RANK THEM
          </button>
          </>
        );
      case 2:
        return (
          <div className='first-time-slider-div'>
            <h3 style={{ marginBottom: "8px" }}>Step 2: And how important are they <i>actually</i> to your search?</h3>
          <div className="slider-container">
            {Object.entries(selectedCharacteristics).map(([id, score]) => (
              <div key={id} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <span style={{ flex: "0 0 150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {characteristics.find((char) => char.id === id)?.name}
                </span>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={score}
                  onChange={(e) => {
                    const newValue = Number(e.target.value);
                    setSelectedCharacteristics((prev) => ({
                      ...prev,
                      [id]: newValue,
                    }));
                  }}
                  style={{
                    flex: "1",
                    margin: "0 10px",
                    background: `linear-gradient(to right, #6867FF 0%, #6867FF ${((score - 1) / 9) * 100}%, #DDDDDD ${((score - 1) / 9) * 100}%, #DDDDDD 100%)`,
                  }}
                />
                <span style={{ width: "30px", textAlign: "center" }}>{score}</span>
              </div>
            ))}
          </div>
            <button className='save-button' onClick={handleSaveStep2} style={{ marginTop: "20px", marginRight: "10px" }}>
              ADD PROPERTIES
            </button>

            <button className='cancel-button' onClick={handleBackStep2} style={{ marginRight: "10px" }}>
              BACK
            </button>
            
          </div>
        );
      case 3:
        return (
          <div>
            <h3>Step 3: Your Properties</h3>
            <button onClick={handleBackStep3} style={{ marginBottom: "10px" }}>
              Back
            </button>
            <PropertiesList
              properties={properties}
              selectedCharacteristics={selectedCharacteristics}
              onDelete={(deletedProperty) => {
                setProperties((prev) =>
                  prev.filter((property) => property.url !== deletedProperty.url)
                );
              }}
            />
          </div>
        );
      default:
        return null;
    }
  };


  const scrapePropertyDetails = async (url) => {
    try {
      const response = await fetch(`${serverUrl}/api/scrape-property`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch property details from backend');
      }

      return await response.json();
    } catch (error) {
      console.error("Error scraping property details:", error);
      return null;
    }
  };

  const handleUpgradeClick = () => {
    logEvent(analytics, "upgrade_modal_shown");
    setShowUpgradeModal(true); // Open the modal
  };

  const closeUpgradeModal = () => {
    setShowUpgradeModal(false); // Close the modal
  };

  const isValidUrl = (url) => {
    try {
        new URL(url);
        return true;
    } catch (_) {
        return false;
    }
  };

  const addProperty = async () => {
    if (!propertyUrl || !isValidUrl(propertyUrl)) {
        setUrlError("Please enter a valid URL"); // Set the error message
        return;
    }

    if (!propertyUrl.includes("rightmove")) {
        setUrlError("Sorry, at present only Rightmove URLs are accepted. "); // Display error message in black
        return;
    }

    setUrlError("");
    setAddError(""); // Clear any previous errors
    setIsAdding(true); // Show loading state

    try {
      const scrapedDetails = await scrapePropertyDetails(propertyUrl);
      if (!scrapedDetails) {
        console.error("Failed to fetch property details. Property not added.");
        return;
      }

      const { title, price, image } = scrapedDetails;
      console.log(title,price,image);

      const newProperty = {
        url: propertyUrl,
        price: price || "N/A", // Default to "N/A" if no price is found
        property_name: title || "Unnamed Property", // Default to "Unnamed Property" if no title is found
        property_image: image || "https://example.com/default.jpg", // Default image if none is found
        ranking: 0, // Dummy value
      };

        const db = getFirestore();
        const userDocRef = doc(db, "userPreferences", user.uid);
        await updateDoc(userDocRef, {
          properties: arrayUnion(newProperty),
        });
        setProperties((prev) => [...prev, newProperty]);
        setPropertyUrl("");
        logEvent(analytics, "property_added_successfully");
        setShowAddPropertyModal(false);
      } catch (error) {
        console.error("Error adding property:", error);
        setAddError("Failed to add property. Please try again.");
      } finally {
        setIsAdding(false); // Hide loading state
      }
  };

const saveCharacteristics = async () => {
  try {
    const db = getFirestore();
    const userDocRef = doc(db, "userPreferences", user.uid);

    // Use updateDoc for more explicit control
    const updatedData = { ...selectedCharacteristics };

    // Check if the document exists
    const docSnap = await getDoc(userDocRef);

    if (docSnap.exists()) {
      // Use updateDoc for existing documents
      Object.keys(updatedData).forEach((key) => {
        if (updatedData[key] === null) {
          updatedData[key] = deleteField();
        }
      });
      await updateDoc(userDocRef, { selectedCharacteristics: updatedData });
    } else {
      // Use setDoc for new documents
      await setDoc(userDocRef, { selectedCharacteristics: updatedData }, { merge: true });
    }
    const isSelected = Object.keys(selectedCharacteristics).length > 0;
    setHasSelectedCharacteristics(isSelected);
    setShowCharacteristicsModal(false); // Close the modal after saving
  } catch (error) {
    console.error("Error updating characteristics:", error);
  }
};


const handleUpgrade = async () => {
  logEvent(analytics, "subscribe_now_clicked");
  try {
    const response = await fetch(`${serverUrl}/api/stripe/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: user.uid }), 
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error from server:", errorText);
      return;
    }

    const { sessionId } = await response.json();
    const stripe = await stripePromise;
    await stripe.redirectToCheckout({ sessionId });
  } catch (error) {
    console.error("Error during upgrade process:", error);
  }
};


  return (

    <div className="properties-page">
    <header className="properties-header">
      <img src='/imgs/domorango.png' alt="My" className="header-logo" />
      <a href="/my-account" className="my-account-link">
        <img src='/imgs/profile-icon.png'  alt="My" className="profile-icon" />
      </a>
    </header>
      {showCelebrationModal && (
    <div className="modal-overlay">
      <Confetti width={width} height={height} numberOfPieces={100} />
      <div className="celebration-modal">
        <h2>🎉 Welcome to Premium! 🎉</h2>
        <p>Thanks, you've successfully upgraded to <b>Premium</b>! Enjoy unlimited properties and access to exclusive future features.</p>
        <button 
          className="explore-premium-button" 
          onClick={() => setShowCelebrationModal(false)}
        >
          Explore Premium Features
        </button>
      </div>
    </div>
  )}
      {showAddPropertyModal && (
          <div className="modal-overlay">
            <div className="add-prop-modal">
              <h2>Add a New Property</h2>
              <input type="text" className='add-prop-input' placeholder="Rightmove Property URL" value={propertyUrl} onChange={(e) => setPropertyUrl(e.target.value)}
              style={{ width: '100%', marginBottom: '10px' }}
              />
              {urlError && (
                <p
                    style={{
                        color: urlError.includes("only Rightmove URLs are accepted") ? 'black' : '#970000',
                        marginBottom: '10px',
                        fontSize: '0.7em',
                    }}
                >
                    {urlError}{" "}
                    {urlError.includes("only Rightmove URLs are accepted") && (
                        <a
                            href="./FAQs"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'blue', textDecoration: 'underline' }}
                        >
                            Learn more.
                        </a>
                    )}
                </p>
            )}

              <div className="modal-buttons">
                <button
                  className="save-button"
                  onClick={addProperty}
                  disabled={isAdding} // Disable button when loading
                >
                  {isAdding ? "Adding..." : "ADD PROPERTY"}
                </button>
                <button
                  className="cancel-button"
                  onClick={() => setShowAddPropertyModal(false)}
                  disabled={isAdding} // Disable cancel while loading
                >
                  CANCEL
                </button>
              </div>
              {addError && (
                <p style={{ color: "red", marginTop: "10px" }}>{addError}</p>
              )}

            </div>
          </div>
        )}

      {showUpgradeModal && (
          <div className="modal-overlay">
            <div className="upgrade-modal">
              <h2>Unlock Premium Features</h2>
              <p>Subscribe to Domogogo Premium to add more than 2 properties and unlock exclusive features:</p>
              <ul>
                <li>Add unlimited properties</li>
                <li>Only £2.99 p/m <b>cancel any time</b></li>
                <li>Priority support</li>
              </ul>
              <div className="premium-modal-buttons">
                <button className="premium-upgrade-button" onClick={handleUpgrade}>
                  Subscribe now
                </button>
                <button className="premium-cancel-button" onClick={closeUpgradeModal}>
                  Cancel
                </button>
              </div>
              <p style={{fontSize: '13px', marginTop:'15px', marginBottom: '0px'}}>For full terms and conditions please see our <a href='terms'>terms of use</a> page</p>
            </div>
          </div>
        )}

      {showCharacteristicsModal && (
          <div
            className="modal-overlay"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
          <div className="modal-content">
            {/* Panels container */}
          <div className="modal-panels">
           <div className="left-panel" style={{ display: "flex", flexWrap: "wrap",}}>
            <h3 style={{ marginBottom: "16px" }}>Select characteristics important to your search</h3>
              {characteristics.map((char, index) => (
                <button
                  key={index}
                  className={`toggle-button ${
                    selectedCharacteristics[char.id] ? "on" : "off"
                  }`}
                  style={{
                    whiteSpace: "nowrap",
                    padding: "4px 8px",
                    borderRadius: "16px",
                    marginRight: "8px",
                    marginBottom: "8px",
                    backgroundColor: selectedCharacteristics[char.id] ? "white" : "white",
                    color: selectedCharacteristics[char.id] ? "black" : "black",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedCharacteristics((prev) => {
                      const updated = { ...prev };
                      if (updated[char.id]) {
                        delete updated[char.id];
                      } else {
                        updated[char.id] = 1; // Default score
                      }
                      return updated;
                    });
                  }}
                >
                {char.url && (
                  <img
                    src={char.url}
                    alt={`${char.name} icon`}
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "8px",
                    }}
                  />
                )}
                  {char.name}
                </button>
              ))}
            </div>
            {/* Right Panel */}
            <div className="right-panel">

            <div style={{width:'100%',}}><h3>And how important are they to you?</h3></div>
            <div className="slider-container">
              {Object.entries(selectedCharacteristics).map(([id, score], index) => (
                <div key={id} style={{display: "flex",alignItems: "center",justifyContent: "space-between",marginBottom: "10px",}}>
                  <span style={{flex: "0 0 120px",textAlign: "right",marginRight: "10px",overflow: "hidden",textOverflow: "ellipsis",whiteSpace: "nowrap",}}
                  title={characteristics.find((char) => char.id === id)?.name}>
                  {characteristics.find((char) => char.id === id)?.name}
                  </span>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                    }}
                  >
                  <input className="char-slider"
                    type="range"
                    min="1"
                    max="10"
                    value={score}
                    onChange={(e) => {
                      const newValue = Number(e.target.value);
                      setSelectedCharacteristics((prev) => ({
                        ...prev,
                        [id]: newValue,
                      }));
                      e.target.style.background = `linear-gradient(to right, #6867FF 0%, #6867FF ${((newValue - 1) / 9) * 100}%, #DDDDDD ${((newValue - 1) / 9) * 100}%, #DDDDDD 100%)`;
                    }}
                    style={{
                      position: "relative",
                      zIndex: "2", // Ensure it's above the touch area
                      background: `linear-gradient(to right, #6867FF 0%, #6867FF ${
                        ((selectedCharacteristics[id] - 1) / 9) * 100
                      }%, #DDDDDD ${((selectedCharacteristics[id] - 1) / 9) * 100}%, #DDDDDD 100%)`,
                      appearance: "none", // Remove default browser styling
                      height: "2px", // Visible slider height
                    }}
                  />
                    {/* Invisible touch area */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-10px", // Extend the touch area above the slider
                      bottom: "-10px", // Extend the touch area below the slider
                      left: "0",
                      right: "0",
                      zIndex: "1", // Ensure it's below the slider
                      cursor: "pointer", // Provide visual feedback on hover
                    }}
                    onClick={(e) => {
                      // Calculate slider position from the click
                      const rect = e.target.getBoundingClientRect();
                      const clickX = e.clientX - rect.left; // Click position within the slider
                      const newValue = Math.round((clickX / rect.width) * 9 + 1); // Map to slider range (1-10)
                      setSelectedCharacteristics((prev) => ({
                        ...prev,
                        [id]: newValue,
                      }));
                    }}
                  ></div>
                </div>
                  <div
                    style={{
                      width: "30px",
                      textAlign: "center",
                    }}
                  >
                  <span
                    style={{
                      textAlign: "center", // Center the score inside the box
                      display: "inline-block", // Ensures consistent spacing
                    }}
                  >{score}</span>
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>
          {/* Bottom Bar */}
          <div className="modal-buttons">
            <button className="save-button" onClick={saveCharacteristics}>
              Save
            </button>
            <button className="cancel-button" onClick={() => setShowCharacteristicsModal(false)}>
              Cancel
            </button>
          </div>
          </div>
        </div>
        )}

      {isCharacteristicsInitialized && !hasSelectedCharacteristics ? (
        <div className='first-time-holder'>{renderStepContent()}</div>
      ) : ( 


      <div className='properties-content'>
        <div className='list-of-properties'>
          <div className="list-header">
            <h3 className="list-title">My Properties</h3>
            <div className="button-group">
              <button
                className={userTier === "basic" && properties.length >= 2 ? "property-action-button-blocked" : "property-action-button"}
                onClick={userTier === "basic" && properties.length >= 2 ? handleUpgradeClick : () => setShowAddPropertyModal(true)}
              >
                {userTier === "basic" && properties.length >= 2 ? "UPGRADE TO ADD MORE" : "ADD PROPERTY"}
              </button>
              <button 
                className="property-action-button" 
                onClick={() => {
                  setShowCharacteristicsModal(true); // Show the modal
                  logEvent(analytics, "reprioritise_modal_shown"); // Log the event
                }}
              >
                UPDATE MY PRIORITIES
              </button>
            </div>
          </div>


        <PropertiesList
          properties={properties}
          userId={user?.uid}
          userTier={userTier}
          characteristics={characteristics}
          selectedCharacteristics={selectedCharacteristics} // Ensure this is added
          onDelete={(deletedProperty) => {
            logEvent(analytics, "property_deleted");
            setProperties((prev) =>
              prev.filter((property) => property.url !== deletedProperty.url)
            );
          }}
          onUpdate={(updatedProperties) => setProperties(updatedProperties)} // Update parent state
        />
        {properties.length === 0 && (
        <div className='placeholder-text'><p>It's time to add your first property!</p></div>
      )}
        </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default Properties;
